module.exports = __webpack_public_path__ + "img/Illustration-CM-2024.196f7eb2.png";